module.exports = __webpack_public_path__ + "static/media/assistance_new.8a2e5e24.jpg";